import { render } from "./IntroHistory.vue?vue&type=template&id=13d06fe8&scoped=true"
import script from "./IntroHistory.vue?vue&type=script&lang=js"
export * from "./IntroHistory.vue?vue&type=script&lang=js"

import "./IntroHistory.vue?vue&type=style&index=0&id=13d06fe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d06fe8"]])

export default __exports__